var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"city-content city-content-chunk-box"},[_c('div',{staticClass:"city-box"},[_c('dv-scroll-board',{staticClass:"dv-scr-board",attrs:{"config":_vm.config}})],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"city-child-head"},[_c('div',{staticClass:"city-child-head-left float-l"},[_c('div',{staticClass:"city-child-head-icon"}),_c('span',[_vm._v("用户动态")])])])
}]

export { render, staticRenderFns }